import React from 'react';
import cn from 'clsx';

import Typography from '../../library/typography/typography';

import styles from './product-warranty.scss';

interface ProductWarrantyProps {
  className?: string;
  miles: string | number | null;
  size?: string;
}

function ProductWarranty(props: ProductWarrantyProps) {
  const { className, miles, size } = props;

  if (!miles || Number(miles) === 0) {
    return null;
  }

  return (
    <Typography
      className={cn(styles['warranty'], className)}
      size={size}
      tag="span"
    >{`${miles} mile warranty`}</Typography>
  );
}

export default ProductWarranty;
